import type { Logo } from '@chownow/pantry/logos';
import { CloverLogoInk, SquareLogoInk } from '@chownow/pantry/logos';

/**
 * Keyed by `pos_resource.type` from GET /api/v2/user. The logo is the only thing
 * BE doesn't send — `display_name` comes off the resource.
 *
 */
export const POS_LOGOS: Record<string, Logo> = {
  clover: CloverLogoInk,
  squareapp: SquareLogoInk,
};

export const POS_DASHBOARD_URLS: Record<string, string> = {
  clover: 'https://www.clover.com/dashboard/',
  squareapp: 'https://app.squareup.com/dashboard/',
};
